import React from 'react';
import type { ComponentProps } from 'react';
import Link from 'next/link';
import { useDeals } from '~/hooks/useDeals';
import { useMessages } from '~/hooks/deals/useMessages';
import Loader from '~/components/common/parts/loading/Loading';
import { PATH as DEALS_PATH } from '~/pages/deals';
import { PATH as DEAL_PATH } from '~/pages/deals/[id]';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { DealLayout } from '~/components/common/layouts/deals/DealLayout';
import { ChatPageContainer } from '~/components/common/chat/ChatPageContainer';
import { useIdQueryHandler } from '~/hooks/useIdQueryHandler';

export const Page: React.FC = () => {
  const id = useIdQueryHandler();
  const { data: deal, isLoading: isLoadingDeal } = useDeals().show(id);
  const {
    data: messages,
    mutate: mutateMessages,
    isLoading: isLoadingMessages
  } = useMessages().index(id);
  const handleMutate = React.useCallback(async () => {
    await mutateMessages?.();
  }, [mutateMessages]);
  if (
    isLoadingDeal ||
    isLoadingMessages ||
    deal === null ||
    messages === null
  ) {
    return <Loader isLoading />;
  }
  const items = [
    { label: '案件一覧', href: DEALS_PATH, as: Link },
    { label: '案件詳細', href: DEAL_PATH(deal.id), as: Link },
    { label: '施工会社とチャット' }
  ] as const satisfies ComponentProps<typeof DealLayout>['items'];
  return (
    <DefaultV2>
      <DealLayout deal={deal} isVendor={false} items={items} useSimpleSpHeader>
        <ChatPageContainer
          deal={deal}
          handleMutate={handleMutate}
          messages={messages}
        />
      </DealLayout>
    </DefaultV2>
  );
};
